module.exports = __webpack_public_path__ + "img/svip1.d70c56c8.png";